import React, {memo, useState} from 'react';

import PropTypes from 'prop-types';
import {IntlProvider, createIntlCache} from 'react-intl';

import enUS from '@/localization/en.json';

import IntlGlobalProvider from './IntlGlobalProvider';

const Messages = {
  en: enUS,
};

// This is optional but highly recommended to prevent memory leak.
const cache = createIntlCache();

function LanguageProvider({children}) {
  const [locale] = useState('en');
  const [messages] = useState(Messages[locale]);

  //   useEffect(() => {
  // TODO: to handle multiple language
  //     setMessages(locale);
  //   }, [locale]);

  return (
    <IntlProvider
      key={cache}
      locale={locale}
      defaultLocale={locale}
      messages={messages}
    >
      <IntlGlobalProvider key={locale}>{children}</IntlGlobalProvider>
    </IntlProvider>
  );
}

LanguageProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(LanguageProvider);
